import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FastSintState } from './fast-sint.state';

const getFastSint = createFeatureSelector<FastSintState>('fastSint');

export const getIsFastSint = createSelector(getFastSint, (state) => !!state?.isFastSint);
export const getFastSintEnabled = createSelector(getFastSint, (state) => !!state?.enabled);
export const getFastSintStores = createSelector(getFastSint, (state) => state.stores);
export const getFastSintShippingStore = createSelector(getFastSint, (state) => state.shippingStore);
export const getFastSintMethod = createSelector(getFastSint, (state) => state.method);
